<template>
  <b-nav-item-dropdown menu-class="media-list dropdown-menu-right" toggle-class="f-s-14" no-caret>
    <template slot="button-content">
      <i class="fas fa-clock"></i>
      <span class="label" v-if="expiringTasksCount > 0">{{ expiringTasksCount }}</span>
      <span class="label" v-else>0</span>
    </template>
    <b-dropdown-header>{{ $t('Tasks expiring within {days} days', { days: expiringTasksDays }) }} ({{ expiringTasksCount }})</b-dropdown-header>
    <b-dropdown-item v-if="expiringTasksList.length === 0" class="text-center">
      <span class="text-muted">{{ $t('No expiring tasks') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-for="task in expiringTasksList"
      :key="task.id"
      class="media"
      @click="goToTask(task)"
    >
      <div class="d-flex">
        <div class="media-body">
          <h6 class="media-heading">{{ task.name }}</h6>
          <small class="text-muted">{{ $t('Due') }}: {{ task.due_date }}</small>
        </div>
      </div>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { TYPES as NOTIFICATION_TYPES } from '@/pages/notify/notification/store'
import { ROUTES as OWNER_ORG_ROUTES } from '@/pages/organization/organization/organization/owner-organization/router'
import { ROUTES as CUSTOMER_ORG_ROUTES } from '@/pages/organization/organization/organization/customer-organization/router'
import {
  EXPIRING_TASKS_POLLING_INTERVAL_MILLISECONDS,
  EXPIRING_TASKS_DAYS
} from '@/const'

export default {
  name: 'ExpiringTasksDropDown',
  data () {
    return {
      interval: undefined,
      expiringTasksDays: EXPIRING_TASKS_DAYS
    }
  },
  created () {
    this.fetch()
    this.interval = setInterval(this.fetch, EXPIRING_TASKS_POLLING_INTERVAL_MILLISECONDS)
  },
  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  computed: {
    ...mapGetters({
      expiringTasksCount: NOTIFICATION_TYPES.GENERIC.notify.notification.DETAIL.GETTERS.expiringTasksCount,
      expiringTasksList: NOTIFICATION_TYPES.GENERIC.notify.notification.DETAIL.GETTERS.expiringTasksList
    })
  },
  methods: {
    ...mapActions({
      getExpiringTasks: NOTIFICATION_TYPES.GENERIC.notify.notification.DETAIL.ACTIONS.getExpiringTasks
    }),
    fetch () {
      this.getExpiringTasks({ days: EXPIRING_TASKS_DAYS })
    },
    goToTask (task) {
      const query = { openTaskId: String(task.id) }
      if (task.category_type_code === 'company') {
        this.$router.push({
          name: OWNER_ORG_ROUTES.OWNER_ORGANIZATION_TASK,
          params: { orgId: String(task.organization) },
          query
        })
      } else {
        this.$router.push({
          name: CUSTOMER_ORG_ROUTES.CUSTOMER_ORGANIZATION_TASK,
          params: {
            orgId: String(task.organization),
            orgType: task.org_type_code
          },
          query
        })
      }
    }
  }
}
</script>
